import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseFunctions';
import { SearchCollectionKey, UpdateSearchIndexRequest } from '#types/System.SearchTypes.types';

type SearchSyncResponse = {
  success: boolean;
  documentId: string;
  error?: string;
}

/**
 * Sync a single document to the search index (Algolia) on demand
 * Generic function that works with any collection defined in SEARCH_INDEX_SYNC_CONFIG
 * 
 * @param collectionKey - Collection key (e.g., 'records', 'formVersions')
 * @param parentId - Parent document ID (e.g., entityId for records, formId for formVersions)
 * @param documentId - Document ID to sync
 * @returns Promise resolving to sync result
 */
export const syncDocumentToSearch = async (
  collectionKey: SearchCollectionKey,
  parentId: string,
  documentId: string
): Promise<SearchSyncResponse> => {
  const syncFn = httpsCallable<UpdateSearchIndexRequest, SearchSyncResponse>(
    functions,
    'updateSearchIndexOnDemand'
  );
  
  const result = await syncFn({ collectionKey, parentId, documentId });
  
  return result.data;
};
